import Swiper from 'swiper/bundle';

const STORAGE_KEY = 'dayprogram_selections';

function getSelections() {
	try {
		return JSON.parse( sessionStorage.getItem( STORAGE_KEY ) ) || {};
	} catch {
		return {};
	}
}

function saveSelections( selections ) {
	try {
		sessionStorage.setItem( STORAGE_KEY, JSON.stringify( selections ) );
	} catch {
		// Storage unavailable: selections simply aren't remembered.
	}
}

function initSwipers() {
	document.querySelectorAll( '.day-program-swiper' ).forEach( ( el ) => {
		const col = el.closest( '.day-program__gallery-col' );
		new Swiper( el, {
			slidesPerView: 1,
			spaceBetween: 16,
			navigation: {
				nextEl: col.querySelector( '.day-program__gallery-next' ),
				prevEl: col.querySelector( '.day-program__gallery-prev' ),
			},
		} );
	} );

	document.querySelectorAll( '.day-program-extras-swiper' ).forEach( ( el ) => {
		const slider = el.closest( '.day-program__extras-slider' );
		new Swiper( el, {
			slidesPerView: 1.2,
			spaceBetween: 16,
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 2.5,
				},
			},
			navigation: {
				nextEl: slider.querySelector( '.day-program__extras-next' ),
				prevEl: slider.querySelector( '.day-program__extras-prev' ),
			},
		} );
	} );
}

function initExtras() {
	// Selections are stored for the last visited tour page only, keyed by post ID:
	// { [tourId]: { title, slug, sections: { [sectionIndex]: [ { index, title, price, section } ] } } }
	const block = document.querySelector( '.day-program[data-tour-id]' );

	if ( ! block ) {
		return;
	}

	const tourId = block.dataset.tourId;
	const tourTitle = block.dataset.tourTitle || '';
	const tourSlug = block.dataset.tourSlug || '';

	// Landing on a tour page resets the stored add-ons to this tour only, so
	// the request form can never receive selections from other tours.
	const stored = getSelections();

	Object.keys( stored ).forEach( ( id ) => {
		if ( id !== tourId ) {
			delete stored[ id ];
		}
	} );
	saveSelections( stored );

	function getTourSections() {
		const tour = getSelections()[ tourId ];
		return ( tour && tour.sections ) || {};
	}

	// Restore previously selected cards.
	const tourSections = getTourSections();

	document.querySelectorAll( '.day-program__extra-card' ).forEach( ( card ) => {
		const section = card.dataset.section;
		const extra = Number( card.dataset.extra );
		const sectionSelections = tourSections[ section ] || [];

		if ( sectionSelections.some( ( item ) => item.index === extra ) ) {
			card.classList.add( 'day-program__extra-card--selected' );
			const btn = card.querySelector( '.day-program__extra-add' );
			if ( btn ) {
				btn.setAttribute( 'aria-pressed', 'true' );
			}
		}
	} );

	// Attach click handlers.
	document.querySelectorAll( '.day-program__extra-add' ).forEach( ( btn ) => {
		btn.addEventListener( 'click', () => {
			const section = btn.dataset.section;
			const extra = Number( btn.dataset.extra );
			const card = btn.closest( '.day-program__extra-card' );
			const current = getSelections();
			const tour = current[ tourId ] || { title: tourTitle, sections: {} };
			tour.slug = tourSlug;
			const sectionItems = tour.sections[ section ] || [];
			const existingIndex = sectionItems.findIndex( ( item ) => item.index === extra );

			if ( existingIndex > -1 ) {
				sectionItems.splice( existingIndex, 1 );
				card.classList.remove( 'day-program__extra-card--selected' );
				btn.setAttribute( 'aria-pressed', 'false' );
			} else {
				sectionItems.push( {
					index: extra,
					title: card.dataset.title || '',
					price: card.dataset.price || '',
					section: card.dataset.sectionTitle || '',
				} );
				card.classList.add( 'day-program__extra-card--selected' );
				btn.setAttribute( 'aria-pressed', 'true' );
			}

			if ( sectionItems.length > 0 ) {
				tour.sections[ section ] = sectionItems;
			} else {
				delete tour.sections[ section ];
			}

			if ( Object.keys( tour.sections ).length > 0 ) {
				current[ tourId ] = tour;
			} else {
				delete current[ tourId ];
			}

			saveSelections( current );
		} );
	} );
}

function initToc() {
	const sections = document.querySelectorAll( '.day-program__section' );
	const tocItems = document.querySelectorAll( '.day-program__toc-item' );

	if ( ! sections.length || ! tocItems.length ) {
		return;
	}

	function setActiveSection( index ) {
		tocItems.forEach( ( item, i ) => {
			item.classList.remove( 'is-active', 'is-visited' );
			if ( i < index ) {
				item.classList.add( 'is-visited' );
			} else if ( i === index ) {
				item.classList.add( 'is-active', 'is-visited' );
			}
		} );
	}

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					setActiveSection( Number( entry.target.dataset.sectionIndex ) );
				}
			} );
		},
		{
			rootMargin: '-20% 0px -60% 0px',
		}
	);

	sections.forEach( ( section ) => observer.observe( section ) );
	setActiveSection( 0 );
}

document.addEventListener( 'DOMContentLoaded', () => {
	initSwipers();
	initExtras();
	initToc();
} );
